<mat-chip-list
  cdkDropList
  (cdkDropListDropped)="handleDrop($event)"
  [cdkDropListOrientation]="vertical ? 'vertical' : 'horizontal'"
  class="rds-c-chip-list"
  [class.no-wrap]="!wrapLabels"
  [disabled]="disabled"
  [selectable]="selectable"
  [attr.aria-label]="ariaLabel"
>
  <mat-basic-chip
    *ngFor="let chip of chips; trackBy: 'id' | mtnaTrackByProperty"
    cdkDrag
    [cdkDragDisabled]="!orderable"
    class="rds-c-chip"
    [class.dense]="dense"
    [disabled]="disabled"
    (click)="handleSelect(chip)"
    (keydown.enter)="handleSelect(chip)"
    (keydown.space)="handleSelect(chip)"
  >
    <span [innerHTML]="chip.label"></span>
    <button *ngIf="removable" [attr.aria-label]="chip.label | rdsRemoveChipLabel" matChipRemove (click)="handleRemove(chip)">
      <mat-icon>cancel</mat-icon>
    </button>
  </mat-basic-chip>
</mat-chip-list>
